import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/true-size-of-territories/page.tsx");
